import {API_MISTA_URL, ID_ASEGURADORA_MISTA, MISTA_API_KEY} from "../utils/constantes";

export default class MistaService {

    static mapearCobertura(cobertura) {
        const sumaAsegurada = (cobertura.coverageValues || []).find(
            (v) => v.type?.code === "INSURED_AMOUNT"
        );

        return {
            nombre: cobertura.coverage?.name || "-",
            tipo: cobertura.type?.name || "-",
            sumaAsegurada: sumaAsegurada?.value ?? null,
            inclusionDate: cobertura.inclusionDate || null,
            exclusionDate: cobertura.exclusionDate || null,
        };
    }

    static mapearPoliza(poliza) {
        const baseData = poliza.policyHeader?.baseData;
        const currency = baseData?.currency;

        return {
            policyCode: poliza.policyCode,
            policyNumber: baseData?.number || "-",
            alias: baseData?.alias || "",
            productName: poliza.policyHeader?.product?.name || "-",
            estado: baseData?.process?.name || "-",
            subsection: poliza.policyHeader?.subsection?.name || "-",
            vigenciaDesde: baseData?.validity?.dateFrom || null,
            vigenciaHasta: baseData?.validity?.dateTo || null,
            currency: currency?.symbol || currency?.mnemonic || "-",
            coverages: (poliza.coverages || []).map((c) => this.mapearCobertura(c)),
        };
    }

    static async obtenerBeneficiario(dni){
        try {
            const myHeaders = new Headers();
            myHeaders.append("X-Api-Key", MISTA_API_KEY);
            myHeaders.append("X-Tenant", "mista");
            myHeaders.append("X-User", "lizen");

            const requestOptions = {
                method: "GET",
                headers: myHeaders,
                redirect: "follow"
            };

            const response = await fetch(`${API_MISTA_URL}/insureds?identificationNumber=${dni}&identificationTypeCode=DNI`, requestOptions);

            if(response.status !== 200){
                return null;
            }

            let beneficiario = await response.json();
            
            if(!beneficiario.policies || !beneficiario.policies[0] || !beneficiario.policies[0].insuredCode){
                throw new Error("Datos de beneficiario incompletos");
            }

            const policiesRaw = beneficiario.policies;
            const policies = policiesRaw.map((p) => this.mapearPoliza(p));
            
            beneficiario = {...beneficiario, ...await this.obtenerDetalleBeneficiario(policiesRaw[0].insuredCode)};

            return {
                dni: beneficiario.identificationNumber,
                apellido: beneficiario.lastName,
                nombre: beneficiario.firstName,
                fecha_nacimiento: beneficiario.birthdate,
                vigencia: policiesRaw[0].coverages?.[0]?.inclusionDate || null,
                vinculo: beneficiario.insuredType?.name || "-",
                poliza: policiesRaw[0].policyCode,
                aseguradora: ID_ASEGURADORA_MISTA,
                domicilio: '-',
                policies,
            };
        } catch (error) {
            console.error("Error al obtener beneficiario de Mista:", error);
            throw new Error(`Error al obtener beneficiario: ${error.message || 'Error desconocido'}`);
        }
    }

    static async obtenerDetalleBeneficiario(codigoBeneficiario) {
        try {
            const myHeaders = new Headers();
            myHeaders.append("X-Api-Key", MISTA_API_KEY);
            myHeaders.append("X-Tenant", "mista");
            myHeaders.append("X-User", "lizen")

            const requestOptions = {
                method: "GET",
                headers: myHeaders,
                redirect: "follow"
            };

            const response = await fetch(`${API_MISTA_URL}/insureds/${codigoBeneficiario}/individual`, requestOptions);

            if(response.status !== 200){
                return null;
            }

            return await response.json();
        } catch (error) {
            console.error("Error al obtener detalle de beneficiario de Mista:", error);
            throw new Error(`Error al obtener detalle de beneficiario: ${error.message || 'Error desconocido'}`);
        }
    }
}
